module.exports = __webpack_public_path__ + "static/img/sai-icon_scroll.d9312c8.gif";